


















import { Component, Prop, Vue } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEdit } from '@fortawesome/free-solid-svg-icons'

library.add(faEdit);

@Component({})
export default class EditButton extends Vue {
  @Prop(Function) handleClick!: any;
  @Prop({ default: () => {} }) butStyle?: any;
}
